import { render, staticRenderFns } from "./LeaveCodeHeader.vue?vue&type=template&id=4149a5ac"
import script from "./LeaveCodeHeader.ts?vue&type=script&lang=ts&external"
export * from "./LeaveCodeHeader.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports